import SiteHeader from '../../components/feature/SiteHeader';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutCredentials from './components/AboutCredentials';
import AboutPhilosophy from './components/AboutPhilosophy';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen" style={{ background: '#ffffff' }}>
      <SiteHeader />
      <main>
        <AboutHero />
        <AboutCredentials />
        <AboutPhilosophy />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}
